<template>
<div class="chapter">
<div class="inner_page">
<p class="supertitle"><a id="ch00_fm03_title"></a><a id="page_iii"><em>FEARLESS</em> <sup>™</sup></a></p><a id="page_iii">
<h1 class="h1">HEAT</h1>
<p class="authorcenter"><span class="smallcaps"><strong>FRANCINE PASCAL</strong></span></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?e88e3e82